// TimeTrigger.ts
// Mirrors ConneXt v2 TimedTrigger: time-based trigger with RepeatAfter support.
import { BaseTrigger } from "./BaseTrigger";
export class TimeTrigger extends BaseTrigger {
    init() {
        if (this.canTrigger()) {
            this.startTimer(() => {
                this.markTriggered();
                this.actionInstance.execute();
            });
        }
    }
}
